import axios from '../axios';
import idToken2User from './idToken2User';

export default async function checkAuth() {
  const { data } = await axios.get('/users/whoAmI');
  return idToken2User(data.auth);
}
